import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.module.css';
import PageHeader from '../../utils/PageHeader/PageHeader';
import NavBar from '../../utils/NavBar/NavBar';
import { Grid } from '@mui/material';
import { STORAGE_KEY } from '../../../const';
import { OrderContext } from '../../../contexts/OrderContext';
import { getDateInYMD } from '../../../helpers/DateFormatHelper';
import OrderView from '../../utils/OrderView/OrderView';
import EmptyCartIcon from '../../icons/emptyCart.png';
import { ShopContext } from '../../../contexts/ShopContext';

const today = new Date().toISOString().split('T')[0];

function Profilte() {
  const { orders, setOrders } = useContext(OrderContext);
  const { shop } = useContext(ShopContext)
  const [orderData, setOrderData] = useState(orders);

  useEffect(() => {
    const sales = localStorage.getItem(`${shop.shopId}-${STORAGE_KEY.ORDERS}`);
    if ((sales || []).length) {
      const salesData = JSON.parse(sales);
      setOrders(salesData);
      setOrderData(salesData);
    }
  }, [setOrders, shop.shopId]);  

  const recentOrders = orderData.filter((order) => getDateInYMD(order.created_at) === today);
  const previousOrders = orderData.filter((order) => getDateInYMD(order.created_at) !== today);

  return (
    <>
      <PageHeader title="Profile" showBackBtn={false} showContact={true} />
      <div className={styles.container}>
        <Grid container>
          <Grid item xs={12} pt={2}>
            <span className={styles.header}>Recent Orders</span>
          </Grid>
          <Grid item container spacing={1} xs={12} pt={2} className={styles.recentOrderContainer}>
            {(recentOrders || []).length > 0 ? (
              recentOrders.map((order) => <OrderView key={order.id} order={order} showDetailsPage={true} />)
            ) : (
              <div className={styles.note}>
                <img
                  src={EmptyCartIcon}
                  alt="Empty Cart"
                  style={{ width: '150px', height: '150px', marginBottom: '20px' }}
                />
                <span> No order found</span>
              </div>
            )}
          </Grid>
          {(previousOrders || []).length > 0 && (
            <>
              <Grid item xs={12} pt={2}>
                <span className={styles.header}>Previous Orders</span>
              </Grid>
              <Grid item container spacing={1} xs={12} pt={2} className={styles.prevOrderContainer}>
                {(previousOrders || []).length > 0 ? (
                  previousOrders.map((order) => <OrderView key={order.id} order={order} showDetailsPage={true} />)
                ) : (
                  <div className={styles.note}>
                    <span> No order found</span>
                  </div>
                )}
              </Grid>
            </>
          )}
          <Grid item xs={12} style={{ height: '65px' }}></Grid>
        </Grid>
        <NavBar />
      </div>
    </>
  );
}

export default Profilte;
